import '../bundle';
import 'videojs-contrib-hls/dist/videojs-contrib-hls';
import 'videojs-resolution-switcher';
import wjplayer from '../wjplayer';
export default wjplayer;



/** WEBPACK FOOTER **
 ** ./src/contrib-hls/index.js
 **/